module.exports = __webpack_public_path__ + "img/icon_health.1f54f1ac.png";